module.exports = __webpack_public_path__ + "static/media/medal-icon.fb091a9c.png";